<template>
                <div class="galerySlider">
                    <div class="galeryWrapper" :style="{ 'width': this.galeryArray.length*this.galerySlider.imageWidth, 'left': (-this.galerySlider.imageWidth*(this.galerySlider.setPage-1))+'px'}">
                        <div v-for="(img,index) in this.galeryArray" class="outer">
                            <div class="inner" :style="GetSmallImage(img)" @click="ImageOpen(index)"></div>
                        </div>
                    </div>
                    <button class="btn btn-primary sliderButtonLeft" @click="galerySlider.setPage>1?galerySlider.setPage -= 1:galerySlider.setPage = galeryArray.length"><span class="glyphicon glyphicon-chevron-left"></span></button>
                    <button class="btn btn-primary sliderButtonRight" @click="galerySlider.setPage<galeryArray.length?galerySlider.setPage += 1:galerySlider.setPage = 1"><span class="glyphicon glyphicon-chevron-right"></span></button>
                </div>          
</template>

<script>
    export default {
        name: 'GalerySlider',
        data: () => ({
            // Default options for the carousel
            elemVisible: 3, // Кол-во отображаемых элементов в карусели
            loop: true,     // Бесконечное зацикливание карусели 
            auto: true,     // Автоматическая прокрутка
            interval: 5000, // Интервал между прокруткой элементов (мс)
            speed: 750,     // Скорость анимации (мс)
            touch: true,    // Прокрутка  прикосновением
            arrows: true,   // Прокрутка стрелками
            dots: true,      // Индикаторные точки
            galerySlider: {
                galerySize: 8, // количество изображений в галерее
                imageWidth: 170, //
                setPage: 1,
                
            },
        }),
        props: {
            galeryAlbum: {
                type: String,
                default: 'none',
            },
            galeryArray: {
                type: Array,
                default: function () {
                    return ['none']
                }
            }
        },
        methods: {
            NewTabUrlOpen(val){
                alert(val)
                window.open(val, '_blank')
            },
            GetSmallImage(img){
                // $store.state.imagesURL +galeryAlbum+ '/' + img + '.jpg
                let imgstyle = 'background-image: '
                if (img.indexOf("youtube.com") >= 0 | img.indexOf("youtu.be") >= 0) {
                    let imgurl = ""
                    imgurl =  imgurl + /^https?\:\/\/(www\.)?youtu\.be/.test(img) ? img.replace(/^https?\:\/\/(www\.)?youtu\.be\/([\w-]{11}).*/,"$2") : img.replace(/.*\?v\=([\w-]{11}).*/,"$1");
                    imgurl = 'https://img.youtube.com/vi/'+imgurl+'/0.jpg'
                    
                    imgstyle += 'url("https://mod.worms.pro/resources/covers/video.png"), url("'+imgurl+'")'
                }
                else {
                    let imgurl = ""
                    imgurl = this.$store.state.imagesURL + this.galeryAlbum + '/' + img + '.jpg'
                    imgstyle += 'url("https://mod.worms.pro/resources/covers/photo.png"), url("'+imgurl+'")'
                }
                console.log(JSON.stringify(imgstyle))
                return imgstyle
            },
            ImageOpen(val){
                this.$root.$emit('ImageShow', val, this.galeryAlbum, this.galeryArray)
            },            
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .galerySlider {
        overflow: hidden;
        position: relative;
        height: 130px;
        padding: 5px 35px;
        margin-bottom: 0px !important;
        background-color: #222;
    }
    .galerySlider .galeryWrapper {
        position: absolute;
        width: 4000px;
        padding: 0;
        height: auto;
        margin-left: 35px;
        transition:0.5s;
    }
    .galerySlider .outer {
        background-color: #fff;

        float: left;
        width: 188px;
        height: 120px;
        margin: 0px 5px;
    }
    .galerySlider .inner {
        background-size: 60px, cover;
        background-repeat: no-repeat;
        background-position: center, center;   
        width: 100%;
        height: 100%;
        cursor: pointer;
    }
    .galerySlider .inner:hover {
        opacity: 0.8;
    }
    .sliderButtonLeft {
        position: absolute;
        left: 0px;
        width: 35px;
        height: 100%;
        margin-top: -5px;
        border-radius: 0px;
        
    }
    .sliderButtonRight {
        position: absolute;
        right: 0px;
        width: 35px;
        height: 100%;
        margin-top: -5px;
        border-radius: 0px;
    }   
</style>



// WEBPACK FOOTER //
// src/components/GalerySlider.vue